<div class="statement ml-4 mr-4 pdf-font-{{ company?.appsettings?.pdfFontSize }}" [hidden]="!isPreview">
  <table class="width-100p">
    <thead class="report-headerr" style="break-inside: avoid; page-break-inside: avoid !important;">
      <div class="statement-header ui-g-12 p-0" style="background-color: white;">
        <!-- Company Details -->
        <span *ngIf="!shopRemit?.addLine1 && !companyRemit?.addLine1">
          <!-- PDF LOGO -->
          <div class="statement-company flex-start-center pdfLogo-enable" *ngIf="company?.pdfLogo">
            <div class="statement-logo pr-3 align-self-start">
              <img [ngClass]="pdfLogoType" class="company-logo" [src]="shop?.pdfLogo || company?.pdfLogo"
                [alt]="company?.name" />
            </div>
          </div>
          <!-- Default logo -->
          <div class="statement-company flex-start-center" *ngIf="!company?.pdfLogo">
            <div class="statement-logo pr-3 align-self-start">
              <img class="company-logo" [src]="shop?.logo || company?.logo" [alt]="company?.name" />
            </div>
            <div class="statement-details flex-column">
              <span class="font-bold">{{ company?.name }}</span>
              <span>{{ company?.phone | mask: '(000) 000-0000' }}</span>
              <span>{{ company?.email }}</span>
              <span>{{ company.formattedAdress }} </span>
              <span *ngIf="company.regNumber && company.regNumber.includes(':')"
                [innerHTML]="this.helperService.formatRegNumber(company?.regNumber)"></span>
              <span *ngIf="company.regNumber && !company.regNumber.includes(':')"> {{'business/GST'|translate}}#: {{
                company?.regNumber
                }} </span>
            </div>
          </div>
        </span>

        <!-- Remit to  -->
        <div class="statement-company flex-start-center" *ngIf="shopRemit?.addLine1 || companyRemit?.addLine1">
          <div class="">
            <div class="font-bold company-name">{{ company?.name }} </div>
            <div class="mb-2 mt-1 remit-container">
              <div class="width-800p">
                <div class="remit">
                  <div class="font-600">{{'remit-to'|translate}}:</div>
                </div>
                <div class="remit-address">
                  <div>{{ shopRemit?.addLine1 || companyRemit?.addLine1}} <br>
                    {{shopRemit?.city || companyRemit?.city}}, {{shopRemit?.stateCode || companyRemit?.stateCode}},
                    {{shopRemit?.state || companyRemit?.state}}, {{shopRemit?.zip || companyRemit?.zip}}
                    {{shopRemit?.country || companyRemit?.country}}
                  </div>
                </div>
              </div>

            </div>

            <div class="width-800p ">
              <div class="phone-container mt-60p ">
                <div class="remit">
                  <div class="font-600">{{'global-payment.phone'|translate}}:</div>
                </div>
                <div class="remit-address">
                  <div>{{ shop?.phone || company?.phone | mask: '(000) 000-0000' }} <span *ngIf="company?.email "
                      class="font-600"><b class="pl-2 pr-2">|</b>{{'global-payment.email'|translate}}: </span>
                    {{shop?.email || company?.email }}</div>
                </div>
              </div>
            </div>

            <div class="width-800p">
              <div class="bill-container mt-170p">
                <div class="remit">
                  <div class="font-600">{{'bill-to'|translate}}:</div>
                </div>
                <div class="remit-address">
                  <div>{{ customer?.fullName}} <br>
                    <div>{{ customer?.address?.addLine1 }} <br>
                      {{customer?.address?.city }}, {{customer?.address?.stateCode }},
                      {{customer?.address?.state }}, {{customer?.address?.zip}}
                      {{customer?.address?.country}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Remit Right section Details -->
        <div class="statement-title remit-container text-right width-320"
          *ngIf="shopRemit?.addLine1 || companyRemit?.addLine1">
          <div class="statement-right flex-column">
            <div class="font-bold">{{ statement?.name }}</div>
            <div class="m-0" *ngIf="statementRange?.start && statementRange?.end">{{ statementRange?.start }} - {{
              statementRange?.end }}</div>
            <div class="font-bold m-0 text-right">{{'balance-due'|translate}}: {{ statementTotal.due || 0 | currency:
              usd }} </div>
            <p class="m-0 text-right">{{ statement?.invoices?.length }} {{'invoice.invoice'|translate}}{{
              statement?.invoices?.length ? 's' : ''
              }}, {{ totalVehicle }} {{'invoice.vehicle'|translate}}{{ totalVehicle ? 's' : '' }}</p>
          </div>
        </div>

        <!-- Estimate Details -->
        <div class="statement-title text-right width-320" *ngIf="!shopRemit?.addLine1 && !companyRemit?.addLine1">
          <div class="statement-right flex-column">
            <span class="font-bold">{{ customer?.fullName }}</span>
            <!-- <span class="font-bold" *ngIf="company?.name && customer?.isFleetCustomer">
              {{ company?.name }}
            </span> -->
            <span>{{ customer?.phone | mask: '(000) 000-0000' }}</span>
            <span class="text-break">{{ customer?.email }}</span>
            <span>{{ customer?.formattedCustomerAddress }}</span>
          </div>
        </div>
      </div>
    </thead>

    <!-- <div class="ui-g-12 mt-0 p-0 mb-2 break-line9" *ngIf="shopRemit?.addLine1 || companyRemit?.addLine1">
      <hr>
      <span class="font-gray-400 flex-center-center">FOLD HERE (#9)</span>
    </div>

    <div class="ui-g-12 mb-4 p-0" *ngIf="shopRemit?.addLine1 || companyRemit?.addLine1">
      <hr>
      <span class="font-gray-400 flex-center-center">FOLD HERE (#10)</span>
    </div> -->

    <tbody class="report-body">
      <tr>
        <div class="statement-customer flex-between-center" *ngIf="!shopRemit?.addLine1 && !companyRemit?.addLine1">
          <div class="flex-column statement-name">
            <p class="font-bold m-0">{{ statement?.name }}</p>
            <p class="m-0 font-600" *ngIf="statementRange?.start && statementRange?.end">{{ statementRange?.start }} -
              {{ statementRange?.end }}</p>
          </div>

          <div class="statement-balance-block flex-column">
            <p class="font-bold m-0 text-right">{{'balance-due'|translate}}: {{ statementTotal.due || 0 | currency: usd
              }}</p>
            <p class="m-0 text-right">{{ statement?.invoices?.length }} {{'invoice.invoice'|translate}}{{
              statement?.invoices?.length ? 's' : ''
              }}, {{ totalVehicle }} {{'invoice.vehicle'|translate}}{{ totalVehicle ? 's' : '' }}</p>
          </div>
        </div>
      </tr>

      <tr class="ind-insepection" [ngClass]="{'break-line9': shopRemit?.addLine1 || companyRemit?.addLine1}">
        <app-statement-item [invoiceLinks]="invoiceLinks" [statementList]="statement?.invoices || []"
          [statementTotal]="statementTotal"> </app-statement-item>
        <div class="page-break-always" *ngIf="upaidStatements && upaidStatements.length > 0"></div>
      </tr>

      <br />
      <tr *ngIf="upaidStatements && upaidStatements.length > 0">
        <div class="statement-customer flex-between-center">
          <div class="flex-column statement-name">
            <p class="font-bold m-0">{{'other-unpaid-statements'|translate}}</p>
            <!-- <p class="m-0 font-600" *ngIf="statementRange?.start && statementRange?.end">
              {{statementRange?.start}} - {{statementRange?.end}}
            </p> -->
          </div>

          <div class="statement-balance-block flex-column">
            <p class="font-bold m-0 text-right">{{'balance-due'|translate}}: {{ statementUnpaidStatementTotal.due || 0 |
              currency: usd
              }}</p>
            <p class="m-0 text-right">{{ upaidStatements.length }} {{'invoice.invoice'|translate}}{{
              upaidStatements.length ? 's' : '' }}, {{
              unpaidTotalVehicle }} {{'invoice.vehicle'|translate}}{{ unpaidTotalVehicle ? 's' : '' }}</p>
          </div>
        </div>
      </tr>

      <tr class="ind-insepection" *ngIf="upaidStatements && upaidStatements.length > 0">
        <app-unpaid-statement-item [invoiceLinks]="invoiceLinks" [statementList]="upaidStatements || []"
          [statementTotal]="statementUnpaidStatementTotal"> </app-unpaid-statement-item>
        <div class="page-break-always"></div>
      </tr>
      <br />

      <ng-container *ngIf="statements && statements.length > 0">
        <ng-container *ngFor="let inv of statements; let i = index">
          <ng-container *ngIf="inv.invoices && inv.invoices.length > 0">
            <tr>
              <div class="statement-customer flex-between-center">
                <div class="flex-column statement-name">
                  <p class="font-bold m-0 capitalize">{{ inv?.name }}</p>
                  <p class="m-0 font-600" *ngIf="statementRange?.start && statementRange?.end">
                    {{ inv?.startDate }} - {{ inv?.endDate }}
                  </p>
                </div>

                <div class="statement-balance-block flex-column">
                  <p class="font-bold m-0 text-right">{{'balance-due'|translate}}: {{ inv?.unpaidTotal?.due || 0 |
                    currency: usd }}</p>
                  <p class="m-0 text-right">{{ inv?.invoices?.length }} {{'invoice.invoice'|translate}}{{
                    inv?.invoices?.length ? 's' : '' }},
                    {{ inv.vehiclesLength }} {{'invoice.vehicle'|translate}}{{ inv.vehiclesLength ? 's' : '' }}</p>
                </div>
              </div>
            </tr>

            <tr class="ind-insepection">
              <app-statement-item [invoiceLinks]="invoiceLinks" [statementList]="inv?.invoices || []"
                [statementTotal]="inv.unpaidTotal"> </app-statement-item>
              <div class="page-break-always" *ngIf="statements.length - 1 > i"></div>
            </tr>
            <br />
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- <tr>
        <div class="statement-footer flex-start-center mt-3 position-relative">
        </div>
      </tr> -->
    </tbody>
  </table>
  <button class="invisible" *ngIf="buttonLoadForstatement" id="button-load-for-statement"></button>
</div>